import React from "react";
/**
 * Render the cell with the number of the week.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function WeekNumber(props) {
    const { week, ...tdProps } = props;
    return React.createElement("td", { ...tdProps });
}
//# sourceMappingURL=WeekNumber.js.map